/* src/app/modules/product-labels/simple-label-preview/simple-label-preview.component.scss */
.vertical-stack-labels {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1 0;
}
.horizontal-list-labels {
  gap: 0.5rem;
  flex: 1 1 0;
  box-sizing: border-box;
  flex-direction: row;
  display: flex;
}
/*# sourceMappingURL=simple-label-preview.component.css.map */
